import * as Yup from "yup";

import { getStartOfDay } from "../../../../utils/dates";

export const expirationExtensionOptions = [
  { label: "30 days", value: "30" },
  { label: "60 days", value: "60" },
  { label: "90 days", value: "90" },
  { label: "Custom date", value: "custom" }
];

export const getExtendExpirationValidationSchema = (
  currentExpirationDate?: Date | null
) => {
  if (!currentExpirationDate) {
    return Yup.object().shape({});
  }

  const startOfTomorrow = getStartOfDay(1);

  return Yup.object().shape({
    extensionType: Yup.string()
      .required("Please select an extension option")
      .oneOf(["30", "60", "90", "custom"]),
    customDate: Yup.date().when("extensionType", {
      is: "custom",
      then: schema =>
        schema
          .required("Custom date is required")
          .min(startOfTomorrow, "Must be after today")
    }),
    reason: Yup.string()
  });
};

export const extendExpirationDefaultValues = {
  extensionType: "30",
  reason: ""
} as const;

export type ExtendExpirationFormData = {
  extensionType: "30" | "60" | "90" | "custom";
  customDate?: Date;
  reason: string;
};

export const getExtendExpirationDate = (
  extensionType: ExtendExpirationFormData["extensionType"],
  value?: Date
) => {
  if (extensionType === "custom") return value;
  return new Date(Date.now() + parseInt(extensionType) * 24 * 60 * 60 * 1000);
};
